import videojs from "video.js/core.es.js";
import { setVideoPause } from "@/stores/experience/actions/timeline";

/**
 * Stop audio/video when overlay iframe is hidden but kept alive for reuse.
 */
export function resumeOverlayPlayback() {
  try {
    setVideoPause("App Controller", false);
  } catch (_e) {
    /* ignore */
  }

  try {
    const players = videojs.getPlayers();
    for (const id in players) {
      if (!Object.hasOwn(players, id)) {
        continue;
      }
      const player = players[id];
      if (player && typeof player.play === "function") {
        player.play().catch(function () {
          /* ignore the rejection */
        });
      }
    }
  } catch (_e) {
    /* ignore */
  }
}

/**
 * True when a player is currently playing. Used to decide whether the portrait
 * chat overlay should resume the video on close -- a viewer who had it paused
 * must not have it started for them.
 */
export function isOverlayPlaying() {
  try {
    const players = videojs.getPlayers();
    for (const id in players) {
      if (!Object.hasOwn(players, id)) {
        continue;
      }
      const player = players[id];
      if (player && typeof player.paused === "function" && !player.paused()) {
        return true;
      }
    }
  } catch (_e) {
    /* ignore */
  }
  return false;
}

export function pauseOverlayPlayback() {
  try {
    setVideoPause("App Controller", true);
  } catch (_e) {
    /* ignore */
  }

  try {
    const players = videojs.getPlayers();
    for (const id in players) {
      if (!Object.hasOwn(players, id)) {
        continue;
      }
      const player = players[id];
      if (player && typeof player.pause === "function") {
        player.pause();
      }
    }
  } catch (_e) {
    /* ignore */
  }

  try {
    const nodes = document.getElementsByTagName("video");
    for (let i = 0; i < nodes.length; i++) {
      nodes[i].pause();
    }
  } catch (_e) {
    /* ignore */
  }
}
